import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

/**
 * Emergency Service - Aligned with backend /api/v1/emergency routes
 * Handles all emergency appointment related API calls
 */
class EmergencyService {
  /**
   * Create an emergency appointment
   * POST /emergency/create (public - no auth required for guests)
   * @param {Object} appointmentData - { crisisType, notes, sessionType, guestInfo, preferredTime, clientId }
   */
  static async createEmergencyAppointment(appointmentData) {
    try {
      const token = localStorage.getItem('token');
      const config = token ? {
        headers: { Authorization: `Bearer ${token}` }
      } : {};

      const response = await axios.post(
        `${API_URL}/emergency/create`,
        appointmentData,
        config
      );

      return response.data;
    } catch (error) {
      console.error('Error creating emergency appointment:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Get crisis resources and hotlines
   * GET /emergency/resources/:crisisType (public)
   */
  static async getCrisisResources(crisisType) {
    try {
      const response = await axios.get(
        `${API_URL}/emergency/resources/${crisisType}`
      );

      return response.data;
    } catch (error) {
      console.error('Error fetching crisis resources:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Link guest appointment to user account
   * POST /emergency/link/:appointmentId (protected)
   */
  static async linkGuestAppointmentToUser(appointmentId) {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const response = await axios.post(
        `${API_URL}/emergency/link/${appointmentId}`,
        {},
        config
      );

      return response.data;
    } catch (error) {
      console.error('Error linking appointment to user:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Cancel emergency appointment
   * DELETE /emergency/cancel/:appointmentId (protected)
   */
  static async cancelAppointment(appointmentId) {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const response = await axios.delete(
        `${API_URL}/emergency/cancel/${appointmentId}`,
        config
      );

      return response.data;
    } catch (error) {
      console.error('Error cancelling appointment:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Get emergency statistics (admin/hod only)
   * GET /emergency/stats (protected - admin/hod only)
   */
  static async getEmergencyStats() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const response = await axios.get(
        `${API_URL}/emergency/stats`,
        config
      );

      return response.data;
    } catch (error) {
      console.error('Error fetching emergency stats:', error);
      throw error.response?.data || error;
    }
  }
}

export default EmergencyService;
